import React, { Component } from "react";
import { connect } from "react-redux";

import classNames from "classnames";
import {
  Input,
  TabNavigation,
  NextStepButton,
  Logo,
  InputError
} from "components";
import { UPDATE_INPUT, MOVE_TAB } from "actions";

class Tab1Turnover extends Component {
  state = {
    isError: false
  };
  submit = () => {
    const v = this.props.companyPredictedTurnover;

    if (parseInt(v, 10) === 0 || v === "" || v === undefined) {
      this.setState({ isError: true });
    } else {
      this.setState({ isError: false });
      this.props.moveToNextTab();
    }
  };

  updateInput = data => {
    const v = data.value;
    if (parseInt(data.value, 10) === 0 || v === "" || v === undefined) {
      this.setState({ isError: true });
    } else {
      this.setState({ isError: false });
    }

    this.props.updateInput(data);
  };
  render() {
    const props = this.props;
    const state = this.state;

    return (
      <div className="form_steps test_tab1_turnover">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            <TabNavigation />
            <div className="form_content">
              <div className="fields_container">
                <div
                  className={classNames("field_block field_block--fill", {
                    error: state.isError
                  })}
                >
                  <label>{props.domain.Strings.tab1TurnoverLabel}</label>
                  <Input
                    prefix={props.domain.Currency}
                    addCommas
                    type="number"
                    value={props.companyPredictedTurnover}
                    onChange={this.updateInput}
                    name="companyPredictedTurnover"
                    className="test_tab1TurnoverInput"
                  />
                  {state.isError && (
                    <InputError
                      label={props.domain.Strings.tab1TurnoverError}
                    />
                  )}
                </div>
                <NextStepButton
                  text={props.domain.Strings.tab1NextBtn}
                  onClick={this.submit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateInput: ({ name, value }) =>
      dispatch({ type: UPDATE_INPUT, name, value }),
    moveToNextTab: () =>
      dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab1Turnover);
